import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {discountInterFace, discountSectionsInterface} from "./discounstInterface";
import {setDiscountSections} from "../../actions/priceWorksheetActions";
import DiscountCommon from "./discountCommon";


class DiscountDeposit extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterFace),
    discountSection: PropTypes.shape(discountSectionsInterface),
  };

  render() {
    const {discount} = this.props;
    return (
      <li className={"discount discount--deposit"}>
        <div className="discount-cell discount-cell--name">{discount.name}</div>
        <div className="discount-cell discount-cell--special-amount">
          {this.renderAmountInput()}
        </div>
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  const {discountSections, customAddedDiscounts} = store.priceWorksheetState;
  return {
    discountSections,
    customAddedDiscounts,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    fabricatorData: store.fabricatorState,
    fabricatorSettings: store.fabricatorState.settings,
  };
};

const mapDispatchToProps = {
  setDiscountSections
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountDeposit);
